import * as React from "react";

import { cn } from "./utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentPropsWithoutRef<"textarea">
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    data-slot="textarea"
    className={cn(
      "resize-none border-input/90 placeholder:text-muted-foreground/80 focus-visible:border-ring focus-visible:bg-card focus-visible:ring-ring/20 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-24 w-full min-w-0 max-w-full rounded-[0.9rem] border bg-input-background/78 px-3.5 py-3 text-base shadow-[inset_0_1px_0_rgb(255_255_255_/_0.2),0_1px_2px_rgb(15_23_42_/_0.04)] backdrop-blur-xl transition-[color,box-shadow,background-color,border-color] outline-none hover:border-accent/45 hover:bg-card/90 focus-visible:ring-[4px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      className,
    )}
    {...props}
  />
));

Textarea.displayName = "Textarea";

export { Textarea };
